import React from 'react'
import {Grid} from '@material-ui/core/'
import MarkDownRenderer from '../components/MarkdownRender'
const RegistryInfo = props => {
    return (
        <Grid container justify="center" alignItems="center">
            <Grid item xs>
                {/* <Grid item xs={12} className='login__logo'>
                    <Typography variant='h3' className='login__title' component='h2'>Registry Info</Typography>
                </Grid> */}

                <Grid item className="login__contanier-info">
                    <MarkDownRenderer value={props.registryInfo || ''} />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default RegistryInfo
